async function addToCart(button) {

  
  var variantId = button.dataset.variantId;
  var variantName = button.dataset.variantName;
  var variantPrice = button.dataset.variantPrice;
  

  const result2 = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity:1,
        })
    });

   const html = await fetch("/?section_id=cart-drawer");
const htmlText = await html.text();


const tempDiv = document.createElement('div');
tempDiv.innerHTML = htmlText;


const requiredCart = tempDiv.querySelector("#drawer-open").innerHTML;

  const cartRes = await fetch("\cart.json");
  const cartResData = await cartRes.json();
  console.log(cartResData.items);
  
  const cartItemArray = cartResData.items;

  const cartCount = document.querySelector(".cart-count-bubble").firstElementChild;
  console.log(cartCount);
  let sum = 0;
  cartItemArray.forEach(e=>{
    sum += e.quantity;
  })
  cartCount.innerHTML = sum;

const cart = document.querySelector("#drawer-open");
cart.classList.remove("is-empty");
cart.innerHTML = requiredCart;


const drawerOpen = document.querySelector("#drawer-open");
drawerOpen.classList.toggle("active");

} 




// --------------------- accordion ------------------------------------


document.addEventListener("DOMContentLoaded", function () {
            const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

            // Expand the first accordion item by default
            /*
            if (accordionItemHeaders.length > 0) {
                accordionItemHeaders[0].classList.add("active");
                const firstAccordionItemBody = accordionItemHeaders[0].nextElementSibling;
                firstAccordionItemBody.style.maxHeight = firstAccordionItemBody.scrollHeight + "px";
            }
                */

            accordionItemHeaders.forEach((accordionItemHeader) => {
                accordionItemHeader.addEventListener("click", (event) => {
                    const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
                    if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
                        currentlyActiveAccordionItemHeader.classList.toggle("active");
                        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
                        currentlyActiveAccordionItemHeader.querySelector(".plus-line").style.opacity = 1;
                        currentlyActiveAccordionItemHeader.querySelector(".minus-line").style.opacity = 0;
                    }
                    accordionItemHeader.classList.toggle("active");
                    const accordionItemBody = accordionItemHeader.nextElementSibling;
                    if (accordionItemHeader.classList.contains("active")) {
                        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
                        accordionItemHeader.querySelector(".plus-line").style.opacity = 0;
                        accordionItemHeader.querySelector(".minus-line").style.opacity = 1;
                    } else {
                        accordionItemBody.style.maxHeight = 0;
                        accordionItemHeader.querySelector(".plus-line").style.opacity = 1;
                        accordionItemHeader.querySelector(".minus-line").style.opacity = 0;
                    }
                });
            });
        });

// --------------------- accordion ---end---------------------------------




// ------------ navbar --------------------------------------

// let prevScrollPos = window.pageYOffset;
// window.onscroll = function() {
//   let currentScrollPos = window.pageYOffset;
//   if (prevScrollPos > currentScrollPos) {
//     document.getElementById("navbar").style.top = "0";
//   } else {
//     document.getElementById("navbar").style.top = "-10vh"; 
//   }
//   prevScrollPos = currentScrollPos;
// }

// ---------------------navbar end----------------- 
document.addEventListener("DOMContentLoaded", function () {
  // scroll is still position
  var scroll = document.documentElement.scrollTop || document.body.scrollTop;
  var header = document.querySelector("#navbar");
  var headerHeight = header.offsetHeight;

  window.addEventListener("scroll", function () {
    // scrolled is new position just obtained
    var scrolled = document.documentElement.scrollTop || document.body.scrollTop;

    // optionally emulate non-fixed positioning behaviour
    if (scrolled > headerHeight) {
      header.classList.add("off-canvas");
    } else {
      header.classList.remove("off-canvas");
    }

    if (scrolled > scroll) {
      // scrolling down
      header.classList.remove("fixed");
    } else {
      //scrolling up
      header.classList.add("fixed");
    }

    scroll = scrolled;
  });
});










// ---------------------------------menu open-close ------------------------------
function openMenu() {
    const mobileMenu = document.querySelector('.mobile-menu');
    const hamburgerMenu = document.querySelector('.hamburger-menu');
 const body = document.querySelector('body'); 
  
    mobileMenu.classList.toggle("mobile-menu-active");
    hamburgerMenu.classList.toggle('open');
     body.classList.toggle('overflow');

  
}
// ---------------------------------------------------------------



// ------new size-box open close add for close when i reach some point it will close ------------------------

function openSizeBox() {
    const sizeboxMenu = document.querySelector('.size-box');
    
    sizeboxMenu.classList.toggle("size-box-active");

    // Add event listener for scroll
    document.addEventListener('scroll', closeSizeBoxOnScroll);
}

function closeSizeBoxOnScroll() {

    const sizeboxMenu = document.querySelector('.size-box');
    const relatedProducts = document.querySelector('.related-products');

    const sizeboxPosition = sizeboxMenu.getBoundingClientRect();
    const relatedProductsPosition = relatedProducts.getBoundingClientRect();

    if (sizeboxPosition.bottom >= relatedProductsPosition.top) {
        sizeboxMenu.classList.remove("size-box-active");
        document.removeEventListener('scroll', closeSizeBoxOnScroll);
    }
}

// ------------------------



// -------------------------------------- faq - accordion -----------------------------------------------

// const faq_11 = () =>{
//     const faq11 = document.querySelector(".faq-page .faq-1");
//     faq11.classList.toggle("open")
// }

// const faq_21 = () =>{
//     const faq21 = document.querySelector(".faq-page .faq-2");
//     faq21.classList.toggle("open")
// }

// const faq_31 = () =>{
//     const faq31 = document.querySelector(".faq-page .faq-3");
//     faq31.classList.toggle("open")
// }


// const faqSection= () =>{
//     const faq_section = document.querySelector(".faq-section");
//     faq_section.classList.toggle("open")
// }

// const faq_1 = () =>{
//     const faq1 = document.querySelector(".faq-1");
//     faq1.classList.toggle("open")
// }

// const faq_2 = () =>{
//     const faq2 = document.querySelector(".faq-2");
//     faq2.classList.toggle("open")
// }

// const faq_3 = () =>{
//     const faq3 = document.querySelector(".faq-3");
//     faq3.classList.toggle("open")
// }

// function sizeGuide(){
//   const sizeContainer = document.querySelector(".size-guide-popup");
//       sizeContainer.classList.toggle("open");
// }

// -------------------------faq-accordion-------------- end-------------